"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoThumbnail = void 0;
var _react = require("react");
var _common = require("b2b-components/theme/common");
var _jsVideoUrlParser = _interopRequireDefault(require("js-video-url-parser"));
const useVideoThumbnail = videoUrl => {
  const [videoThumbnail, setVideoThumbnail] = (0, _react.useState)(null);
  if (!videoUrl) {
    return null;
  }
  const {
    id: videoId
  } = _jsVideoUrlParser.default.parse(videoUrl);
  if (videoUrl.includes(_common.VIDEO_TYPE.youtube)) {
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  }
  if (videoUrl.includes(_common.VIDEO_TYPE.vimeo)) {
    fetch(`https://vimeo.com/api/v2/video/${videoId}.json`).then(response => response.json()).then(data => setVideoThumbnail(data[0].thumbnail_large));
  }
  return videoThumbnail;
};
exports.useVideoThumbnail = useVideoThumbnail;
//# sourceMappingURL=useVideoThumbnail.js.map